export default {
  title: 'Lista de blockchains compatibles con KeyPal (1000+)',
  getKeypal: 'Consigue tu KeyPal',
  comingSoon: 'Próximamente',
  list: {
    title: 'Blockchain',
    detail: 'Detalles',
    urlName: 'Enlace',
  },
}
